import { DataBox } from './DataBox'
import { baseModel } from '../model'
import { PageHeader } from './PageHeader'
import { EditModal } from './editModal'
import { DetailModal } from './detailModal'

const MainComponent = () => {
    const { editVisible, detailVisible } = baseModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            {editVisible && <EditModal />}
            {detailVisible && <DetailModal />}
        </>
    )
}
export default MainComponent
